import { PDFArray, PDFDict, PDFDocument, PDFName, PDFRawStream } from "pdf-lib";

export default { PDFArray, PDFDict, PDFDocument, PDFName, PDFRawStream };
